import { j as o } from "../../_virtual/jsx-runtime.js";
const l = ({
  width: r = 20,
  height: s = 20,
  viewBox: t = "0 0 20 20",
  fill: n = "currentColor",
  ...e
}) => /* @__PURE__ */ o.jsx(
  "svg",
  {
    width: r,
    height: s,
    viewBox: t,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: /* @__PURE__ */ o.jsx(
      "path",
      {
        d: "M13.9645 2.49732L12.2978 4.16398H4.16667V15.8307H15.8333V7.69953L17.5 6.03286V16.664C17.5 17.1243 17.1269 17.4973 16.6667 17.4973H3.33333C2.8731 17.4973 2.5 17.1243 2.5 16.664V3.33065C2.5 2.87042 2.8731 2.49732 3.33333 2.49732H13.9645ZM17.0711 1.74774L18.2496 2.92625L10.5892 10.5866L9.41283 10.5887L9.41075 9.40808L17.0711 1.74774Z",
        fill: n
      }
    )
  }
);
export {
  l as default
};
